export default "__VITE_ASSET__ByX3a$AO__"